/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Status_StartingInputs */

const en_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting media import...`)
};

const fr_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage de l'importation des medias...`)
};

const de_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport wird gestartet...`)
};

const it_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio importazione media...`)
};

const ru_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало импорта медиафайлов...`)
};

const es_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando importación de medios...`)
};

const zh_cn2_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导入媒体文件...`)
};

const ja_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートを開始しています...`)
};

const hi_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात शुरू हो रहा है...`)
};

const pt_pt2_media_import_status_starting = /** @type {(inputs: Media_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a importação de mídia...`)
};

/**
* | output |
* | --- |
* | "Starting media import..." |
*
* @param {Media_Import_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_status_starting = /** @type {((inputs?: Media_Import_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_status_starting(inputs)
	if (locale === "de") return de_media_import_status_starting(inputs)
	if (locale === "it") return it_media_import_status_starting(inputs)
	if (locale === "ru") return ru_media_import_status_starting(inputs)
	if (locale === "es") return es_media_import_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_status_starting(inputs)
	if (locale === "ja") return ja_media_import_status_starting(inputs)
	if (locale === "hi") return hi_media_import_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_status_starting(inputs)
	return en_media_import_status_starting(inputs)
});